module.exports = __webpack_public_path__ + "fonts/e22062b.ttf";